import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Icon from '../../Icon';

const Container = styled.div`
	padding: 40px;
`;

const HeadWrapper = styled.div`
`;

const Head = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 0 0 40px;
`;

const Name = styled.h1`
  margin: 0;
`;

const City = styled.h2`
  font-weight: normal;
  margin: 8px 0 0;
`;

const BodyContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	@media (max-width: 1200px) {
		flex-direction: column;
		margin-left: 40px;
		justify-content: flex-start;
	}
`;

const DetailsContainer = styled.div`
  display: flex;
  font-size: 14px;
	color: #787878;
	justify-content: space-between;
`;

const CloseImagesLink = styled(Link)`
	color: #4A90E2;
	text-decoration: none;
	display: flex;
	align-items: center;

	&:hover {
		text-decoration: underline;
	}
`;

const CloseIcon = styled(Icon)`
	margin-left: 8px;

	svg {
		fill: #4A90E2;
	}
`;

export {
	Container,
	Head,
	HeadWrapper,
	Name,
	City,
	BodyContainer,
	DetailsContainer,
	CloseImagesLink,
	CloseIcon,
}
